import { Release } from '../../types/release'
import { ReleaseGrid } from './ReleaseGrid'
import { ReleaseCrateView } from './ReleaseCrateView'
import styles from '../../pages/PageStyles.module.css'

interface ReleaseListViewProps {
  releases: Release[]
  viewMode: 'grid' | 'crate'
  draggable?: boolean
  /** Bootstrap icon class for empty state (default: 'bi bi-vinyl') */
  emptyIcon?: string
  /** Empty state message */
  emptyMessage?: string
  /** Empty state hint */
  emptyHint?: string
  onRemove?: (id: number) => void
  showRemoveButton?: boolean
}

export function ReleaseListView({
  releases,
  viewMode,
  draggable = true,
  emptyIcon = 'bi bi-vinyl',
  emptyMessage = 'No releases found',
  emptyHint,
  onRemove,
  showRemoveButton,
}: ReleaseListViewProps) {
  if (viewMode === 'crate') {
    return releases.length > 0 ? (
      <ReleaseCrateView releases={releases} />
    ) : (
      <div className={styles.empty}>
        <i className={emptyIcon}></i>
        <p>{emptyMessage}</p>
        {emptyHint && <p className={styles.emptyHint}>{emptyHint}</p>}
      </div>
    )
  }

  return releases.length > 0 ? (
    <ReleaseGrid
      releases={releases}
      draggable={draggable}
      onRemove={onRemove}
      showRemoveButton={showRemoveButton}
    />
  ) : (
    <div className={styles.empty}>
      <i className={emptyIcon}></i>
      <p>{emptyMessage}</p>
      {emptyHint && <p className={styles.emptyHint}>{emptyHint}</p>}
    </div>
  )
}
